<template>
  <div class="Annouce">
    <div class="annouce">
      <div class="title">
        <div>{{ $t('local_annouce_title') }}</div>
        <a
          href="https://bonuscloud.gitbook.io/help"
          target="_blank"
        >
          <div class="more bonus-cursor">{{ $t('annouce_more')}} >></div>
        </a>
      </div>
      <div class="annouce-content">
        <el-table
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            class-name="data"
            prop="date"
            height="40px"
            width="90px"
          >
          </el-table-column>
          <el-table-column
            class-name="detail-more"
            height="40px"
          >
            <template slot-scope="scope">
              <a
                target="_blank"
                :href="scope.row.link"
              >
                <span v-bind:class="{ activeAnnouce: (scope.$index === 0 || scope.$index === 3)}">{{scope.row.content}}</span>
              </a>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<i18n>
{
  "en": {
		"annouce_more": "more"
  },
  "zn": {
		"annouce_more": "查看更多"
  }
}
</i18n>

<script>
export default {
  name: "Annouce",
  computed: {
    // 计算属性的 getter
    tableData: function() {
      // `this` 指向 vm 实例
      let tableData = Object.values(this.$t("local_annouce"));
      return tableData;
    }
  }
};
</script>

// 公告展示内容
<i18n>
{
  "en": {
		"local_annouce_title": "Annoucement",
    "local_annouce": [{
        "date": "2018.11.11",
				"content": "Guide for Beginners",
				"link": "https://bonuscloud.club/viewtopic.php?f=18&t=17"
      }, {
        "date": "2018.10.10",
				"content": "BonusCloud White Paper",
				"link": "https://bonuscloud.gitbook.io/help/bonuscloud-whitepaper-v-1.1-2018"
      }, {
        "date": "2018.10.10",
				"content": "BonusCloud Tutorial (BonusCloud only provides ROM and tutorials. Please be noted that brushing machine remains certain risks assumed by you, and BonusCloud bears no responsibility for any potential risk.)",
				"link": "https://bonuscloud.club/viewforum.php?f=19"
      }, {
        "date": "2019.06.06",
				"content": "Note: please keep the NAT traversal of device for running computing task in normal status, in order to get the corresponding revenue stably. (computing task - task operation status )",
				"link": "https://bonuscloud.club/viewtopic.php?f=15&t=5445"				
      }]
  },
  "zn": {
		"local_annouce_title": "公告",
    "local_annouce": [{
        "date": "2019.12.11",
				"content": "新手入门（设备选择、镜像下载、刷机导航、常见问题等）",
				"link": "https://bonuscloud.club/viewtopic.php?f=15&t=12"
      }, {
        "date": "2018.10.10",
				"content": "BonusCloud 白皮书",
				"link": "https://bonuscloud.gitbook.io/help/bonuscloud-bai-pi-shu-v1.0"
      }, {
        "date": "2018.10.10",
				"content": "BonusCloud 刷机教程（BonusCloud只提供镜像及教程，不负责刷机技术支持，刷机有风险，自行担责）",
				"link": "https://bonuscloud.club/viewtopic.php?f=15&t=2014"
      }, {
        "date": "2019.06.06",
				"content": "注意：计算任务设备请保持网络穿透正常 ,以获得稳定任务收益（计算任务-任务执行状态）",
				"link": "https://bonuscloud.club/viewtopic.php?f=15&t=5445"				
      }]
  }
}
</i18n>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="stylus">
.annouce .el-table__header-wrapper {
  display: none;
}

.annouce .el-table th {
  padding: 5px 0;
  font-sice: 12px;
}

.el-table .el-table__body td {
  font-sice: 12px;
}

.annouce td {
  padding: 5px 0;
}

.detail-more .cell {
  text-align: left;
}

.annouce-content .data {
  font-size: 14px;
  color: #96999B;
  line-height: 23px;
}

.annouce-content .cell {
  font-size: 12px;
}

.annouce-content .data .cell {
  text-align: left;
  font-size: 12px;
}

a {
  color: #96999b;
}

.annouce-content .detail-more span.activeAnnouce {
  color: #f56c6c;
}
</style>
